<template>
  <Teleport to=".js-cart-urgency-nudge">
    <div class="Cart__Alert" :class="active">
      <div class="Cart__AlertWrapper">
        <div class="Cart__AlertModal">
          <div class="Cart__AlertClose">
            <button role="button" aria-label="close alert" @click="close">
              <Icon icon="close" />
            </button>
          </div>
          <h3 class="h3 Cart__AlertTitle">
            {{ store.terms.urgency.nudge_title }}
          </h3>
          <p class="Cart__AlertCopy p4">
            {{ store.terms.urgency.nudge_copy }}
          </p>
          <div class="Cart__AlertClose">
            <a href="/checkout" class="t5" @click.prevent="close">
              {{ store.terms.urgency.nudge_cta }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed } from 'vue';
import { pubSub } from '@utils/PubSub';
import { useCartStore } from './Composables/Store';

import Icon from '../Global/Icon.vue';

const store = useCartStore();
const visible = ref(false);
const seen = ref(false);
const active = computed(() => (visible.value ? 'Cart__Alert--Active' : ''));
const template = document.querySelector('body');

const display = () => {
  seen.value = JSON.parse(sessionStorage.getItem('urgencyModalShown')) ?? false;
  if (!seen.value) {
    template.classList.add('no-scroll');
    visible.value = true;
  }
};

const close = (e) => {
  const anchorTagSelected = e.target.nodeName === 'A';

  visible.value = false;
  template.classList.remove('no-scroll');
  sessionStorage.setItem('urgencyModalShown', true);

  if (anchorTagSelected) {
    location.href = e.target.href;
  }
};

pubSub.subscribe('cart:urgency:nudge', display);
</script>
